import React from 'react';
import Layout from '../../components/Layout';
import { getUserInfo } from '../../user';
import { Navigate } from 'react-router-dom';
import TrialTypeTable from '../../components/TrialTypeTable';

export default function TrialType() {
  const [user, setUser] = React.useState(null);
  React.useEffect(() => {
    getUserInfo().then(setUser);
  }, []);
  if (!user) return null;
  if (!Array.isArray(user.roles) || !user.roles.includes('admin')) return <Navigate to="/" replace />;
  return (
    <Layout>
      <h1 className="text-2xl font-bold mb-4">Trial Types</h1>
      <TrialTypeTable />
    </Layout>
  );
}
